<template>
  <div class="page mypage password_update px-3 pb-3 pt-10">
    <page-header
      has-back>
      メールアドレスの変更
    </page-header>
    <p>現在登録されているメールアドレスを変更します。</p>
    <div class="mypage__body general-form">
      <form
        v-if="initialized">
        <validation-observer
          ref="observer"
          v-slot="observer">
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              for="inputPassword1"
              class="col-form-label">現在登録されているメールアドレス</label>
            <b-form-input
              v-model="account.email"
              disabled />
            <label
              for="inputPassword1"
              class="col-form-label mt-3">変更後のメールアドレス</label>
            <validation-provider
              v-slot="v" 
              vid="email"
              name="メールアドレス"
              rules="email|required">
              <p class="fs-s">
                ※ログインIDになりますので忘れないようにしてください。
              </p>
              <b-form-input
                v-model="email"
                type="email"
                placeholder="sample@t-today.jp" />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__btn row mt-5">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-cancel"
                @click="onClickCancel">
                キャンセル
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                保存
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/parts/PageHeader.vue'
export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      initialized: false,
      account: null,
      email: '',
      apiErrors: null,
    }
  },
  watch: {
    apiErrors(val) {
      if (val) {
        this.$refs.observer.setErrors(val)
      }
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.fetchAccountMe()
    this.initialized = true
    this.$store.commit('finishLoading')
  },
  methods: {
    async onClickSave() {
      this.$store.commit('startLoading')
      this.$axios.patch('/accounts/me/', {email: this.email}).then(() => {
        this.$store.commit('notify/set', {message: '保存しました。'})
        this.$router.push('/settings/')
      }).catch((e) => {
        console.error(e)
        this.apiErrors = e.response.data
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    async fetchAccountMe() {
      const account = await this.$axios.get('/accounts/me/')
      this.account = account.data
    },
    onClickCancel() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>